export const environment = {
  production: true,
  emrUrl : "https://pristyntech.com/emr/",
  trainingUrl: "https://pristyntech.com/leadsAlternative/",
  docServiceUrl: "https://pristyntech.com/",
  baseUrl: 'https://pristyntech.com/'
};
